import { HomeSellingOptionsButton } from "./home.selling-options.button";
import { HomeSellingOptionsForm } from "./home.selling-options.form";

export const HomeSellingOptions = {
    Button: HomeSellingOptionsButton,
    Component: HomeSellingOptionsForm,
}

export * from './home.selling-options.types'
